module.exports = __webpack_public_path__ + "static/media/wizualizacja-27.6ef2e682.png";